import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import type { FinalCtaContent } from '../../types/salesPage';
interface FinalCtaProps {
  content: FinalCtaContent;
  checkoutUrl: string;
  price: string;
  totalValue: string;
}
export function FinalCta({
  content,
  checkoutUrl,
  price,
  totalValue
}: FinalCtaProps) {
  return <section id="comprar" aria-labelledby="final-cta-title" className="relative scroll-mt-16 overflow-hidden border-t border-white/[0.07] bg-ink px-5 py-16 sm:px-6 md:py-24" data-id="element-103" data-mp="2xa5okp0i9ar3">
      <div aria-hidden="true" className="grain-overlay absolute inset-0 opacity-60" data-id="element-104" data-mp="3pytgv4jo90e5" />
      <div aria-hidden="true" className="absolute left-1/2 top-0 h-[360px] w-[760px] -translate-x-1/2 bg-[radial-gradient(ellipse_at_top,rgba(210,165,81,0.12),transparent_62%)]" data-id="element-105" data-mp="3c3injvl2snbw" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-70px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="relative mx-auto max-w-3xl text-center" data-id="element-106" data-mp="20oc6yto77iwq">
        <h2 id="final-cta-title" className="font-serif text-[26px] font-bold leading-tight text-parchment sm:text-[32px] md:text-[42px]" data-id="element-107" data-mp="3i8lz4icmdpog">
          {content.title}
        </h2>

        {content.paragraphs.map(paragraph => <p key={paragraph} className="mx-auto mt-4 max-w-2xl text-[15px] font-light leading-[1.72] text-ash md:text-[16.5px]" data-id="element-108" data-mp="9z3yd2f72q0y">
            {paragraph}
          </p>)}

        <div className="mt-8 inline-flex items-baseline gap-3 font-mono" data-id="element-109" data-mp="jpow6nn1nqit">
          <s className="text-[15px] text-[#C98A8A] decoration-[#C98A8A]" data-id="element-110" data-mp="eqlzprl4qsmg">{totalValue}</s>
          <span className="font-serif text-[42px] font-extrabold text-gold-soft md:text-[52px]" data-id="element-111" data-mp="sq3h3lw3j3ls">
            {price}
          </span>
        </div>

        <a href={checkoutUrl} className="group mx-auto mt-6 flex max-w-2xl items-center justify-center gap-2.5 rounded-sm bg-gold px-5 py-4 text-center font-mono text-[10.5px] font-bold uppercase leading-tight tracking-[0.05em] text-[#181205] shadow-[0_16px_34px_rgba(200,151,63,0.28)] transition-colors duration-200 hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-[12.5px] md:px-7 md:py-5" data-id="element-112" data-mp="optcodnycl91">
          {content.ctaLabel}
          <ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-113" data-mp="1jhat7xtfan1z" />
        </a>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-114" data-mp="1oeaulvfbv1mr">
          {content.microcopy.map(item => <li key={item} className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.1em] text-ash/80 md:text-[10px]" data-id="element-115" data-mp="3q8a5ifojfgyx">
              <Check aria-hidden="true" className="h-3.5 w-3.5 text-gold/80" data-id="element-116" data-mp="2cbpc2svuf72k" />
              {item}
            </li>)}
        </ul>
      </motion.div>
    </section>;
}